import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';

interface InputProps extends FormlyFieldProps {
  readonly: boolean;
}

@Component({
    selector: 'lockton-apps-confirmation-box-type',
    templateUrl: './confirmation-box-type.component.html',
    styleUrls: ['./confirmation-box-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConfirmationBoxTypeComponent extends FieldType<
  FieldTypeConfig<InputProps>
> {}
